import React, { useState } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Formik, Form } from 'formik';
import GreenButton from '../Shared/GreenButton';
import { useTranslation } from 'react-i18next';
import RawMaterialsTable from './RawMaterialsTable';
import AdditivesTable from './AdditivesTable';
import * as Yup from 'yup';

export default function ManualReplenishmentDrawer(props) {
    const classes = useStyles();

    const [materials, setMaterials] = useState([]);

    const { t } = useTranslation();

    let shape = {}
    let initialValues = {}

    var i;
    for (i = 0; i < props.productionOrder.bomIn.length; i++) {
        let quantityName = 'quantity' + props.productionOrder.bomIn[i].productId
        shape[quantityName] = Yup.number().moreThan(0, "quantity can not be zero")

        initialValues[quantityName] = ""
    }

    function quantityChanged(e, id) {
        let tempMaterials = Object.assign([], materials);
        if (tempMaterials.some(x => x.id === id)) {
            tempMaterials.find(x => x.id === id).quantity = e.target.value.toString()
        }
        else {
            tempMaterials.push({ id: id, quantity: e.target.value })
        }

        setMaterials(tempMaterials)
    }

    function addMaterialAmounts() {
        materials.map(x => {
            if (x.quantity !== "") {
                props.replenishmaterial(x.quantity, x.id)
            }
        })
        setMaterials([])
        props.opendrawer(false)
    }

    function closeDrawer() {
        setMaterials([])
        props.opendrawer(false)
    }

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.draweropen} classes={{ paper: clsx({ [classes.drawerOpen]: props.draweropen, [classes.drawerClose]: !props.draweropen, }), }} onClose={() => closeDrawer()} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{t("Manual replenishment")}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => closeDrawer()}>
                        <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                    </Button>
                </div>
            </div>
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape(shape)}
            >
                {({ isValid, touched }) => (
                    <Form autoComplete="off">
                        <div className={classes.materials}>
                            <div className={classes.tableTitle}>
                                {t("How much would you like to add?")}
                            </div>
                            <div className={classes.consumptionTable}>
                                <RawMaterialsTable quantityChanged={quantityChanged} productionOrder={props.productionOrder} {...props}></RawMaterialsTable>
                                {/* <AdditivesTable quantityChanged={quantityChanged} purchaseNumberChanged={purchaseNumberChanged} productionOrder={props.productionOrder} {...props}></AdditivesTable> */}
                            </div>
                        </div>
                        <div className={classes.addMaterialAmounts}>
                            <GreenButton onClick={addMaterialAmounts} text={"ADD MATERIAL AMOUNTS"} disabled={!isValid || (Object.entries(touched).length === 0)}></GreenButton>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        padding: "40px",
        paddingTop: "0px",
        paddingLeft: "20px"

    },
    closeButton: {
        float: "right",
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "36px !important",
        height: "36px !important",
        minWidth: "36px !important",
        marginTop: "10px"
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "60%",
        backgroundColor: "#EFEFEF",
        paddingRight: "40px",
    },
    drawerClose: {
        width: 0
    },
    header: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        width: "100%",
        height: '70px',
        display: "block"
    },
    tableTitle: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginBottom: "30px"
    },
    title: {
        width: "80%",
        float: 'left',
        marginTop: "20px",
    },
    materials: {
        display: 'block',
        width: "100%"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
    },
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    typeCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px"
    },
    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE",
        backgroundColor: "white"
    },
    amountCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE",
        borderRight: "1px solid #DEDEDE",
        borderRadius: " 0 6px 6px 0",
        backgroundColor: "white",
        width: "30%",
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"

    },
    batchnumberTextField: {
        width: "100%"
    },
    quantityTextField: {
        width: "100%"
    },
    addMaterialAmounts: {
        width: "100%",
        textAlign: "center",
        marginTop: "40px"
    },

}));